// import AOS from "aos";
// import "aos/dist/aos.css";

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// Lenis
import Lenis from '@studio-freight/lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Rejestracja pluginu ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// ========================
// LENIS – smooth scroll
// ========================
function initLenis() {
    const lenis = new Lenis({
        duration: 1.45,
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        mouseMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
    });

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
}

// ========================
// MAIN INIT
// ========================
(function($) {
    init();

    function init() {
      initFancybox();
      knowledgeFillter();
      initKnowledgeTypeFilter();
        knowledgeFilter();
        initGsapParallax();
        initLenis();
        initSwiper();
        //initAOS();
        handleHamburger();
        handleLazyLoading();
        handlePlaceholders();
        langSwitcher();
        faq();
        teamFilters();
        accordingServices()
    }

    // AOS
    // function initAOS() {
    //     AOS.init({
    //         duration: 800,
    //         once: true,
    //     });
    // }

    function initFancybox() {
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Toolbar: {
      display: [
        { id: "counter", position: "center" },
        "close",
      ],
    },
    dragToClose: true,
    placeFocusBack: false,
    animated: true,
    autoFocus: false,
    hideScrollbar: true,
    l10n: {
      CLOSE: "Zamknij",
      NEXT: "Następne",
      PREV: "Poprzednie",
    },
  }); 

}

function knowledgeFillter() {
  const container = document.querySelector('#knowledge-archive-content');
  if (!container) return;

  // 🔹 Kliknięcie w główną kategorię
  document.addEventListener('click', function (e) {
    const mainBtn = e.target.closest('.knowledge-main-cat-btn');
    if (!mainBtn) return;

    e.preventDefault();

    const catId = mainBtn.getAttribute('data-cat-id');

    // aktywny stan
    document.querySelectorAll('.knowledge-main-cat-btn').forEach(btn => btn.classList.remove('active'));
    mainBtn.classList.add('active');

    // przygotowanie danych AJAX
    const data = new FormData();
    data.append('action', 'filter_knowledge');
    data.append('cat_id', catId);

    // efekt ładowania
    container.classList.add('loading');

    fetch(mg_ajax.ajax_url, {
      method: 'POST',
      body: data,
    })
      .then(res => res.json())
      .then(response => {
        if (response.success) {
          container.innerHTML = response.data;
        } else {
          container.innerHTML = '<p>Brak materiałów w tej kategorii.</p>';
        }
        container.classList.remove('loading');
      })
      .catch(err => {
        console.error('AJAX error:', err);
        container.classList.remove('loading');
      });
  });

  // 🔸 Kliknięcie w podkategorię
  document.addEventListener('click', function (e) {
    const subcatLink = e.target.closest('.knowledge-cat-link');
    if (!subcatLink) return;

    e.preventDefault();

    const subcatId = subcatLink.getAttribute('data-subcat-id');
    const section = subcatLink.closest('.knowledge-archive-section');
    if (!section) return;

    const typeSlug = section.getAttribute('data-type');
    const sectionContainer = section.querySelector('.knowledge-list');

    // stan aktywny
    section.querySelectorAll('.knowledge-cat-link').forEach(link => link.classList.remove('active'));
    subcatLink.classList.add('active');

    const data = new FormData();
    data.append('action', 'filter_knowledge');
    data.append('subcat_id', subcatId);
    data.append('type_slug', typeSlug);

    section.classList.add('loading');

    fetch(mg_ajax.ajax_url, {
      method: 'POST',
      body: data,
    })
      .then(res => res.json())
      .then(response => {
        if (response.success && sectionContainer) {
          const temp = document.createElement('div');
          temp.innerHTML = response.data.trim();

          const newList = temp.querySelector('.knowledge-list');
          sectionContainer.innerHTML = newList ? newList.innerHTML : response.data;
        }
        section.classList.remove('loading');
      })
      .catch(err => {
        console.error('AJAX error:', err);
        section.classList.remove('loading');
      });
  });
}

   function initKnowledgeTypeFilter() {
  const newsWrapper = document.querySelector('.news .container'); // główny kontener sekcji
  const filterBar = document.querySelector('.knowledge-categories-bottom');

  if (!newsWrapper || !filterBar) return;

  filterBar.addEventListener('click', (e) => {
    const link = e.target.closest('.knowledge-cat-link');
    if (!link) return;

    e.preventDefault();

    const subcatId = link.getAttribute('data-subcat-id');
    const typeSlug = document.body.dataset.currentType; // ustawione w PHP
    if (!typeSlug) return;

    // 🔹 aktywny stan
    filterBar.querySelectorAll('.knowledge-cat-link').forEach(btn => btn.classList.remove('active'));
    link.classList.add('active');

    // 🔹 dane AJAX
    const data = new FormData();
    data.append('action', 'filter_knowledge_type');
    data.append('subcat_id', subcatId);
    data.append('type_slug', typeSlug);

    newsWrapper.classList.add('loading');

    fetch(mg_ajax.ajax_url, {
      method: 'POST',
      body: data
    })
      .then(res => res.json())
      .then(response => {
        if (response.success) {
          // usuń stare elementy
          newsWrapper.querySelector('.news-list')?.remove();
          newsWrapper.querySelector('.pagination')?.remove();

          // wstaw nowe
          const temp = document.createElement('div');
          temp.innerHTML = response.data.trim();

          const newList = temp.querySelector('.news-list');
          const newPagination = temp.querySelector('.pagination');

          if (newList) newsWrapper.appendChild(newList);
          if (newPagination) newsWrapper.appendChild(newPagination);
        } else {
          newsWrapper.innerHTML = '<p>Brak wpisów.</p>';
        }

        newsWrapper.classList.remove('loading');
      })
      .catch(err => {
        console.error('AJAX error:', err);
        newsWrapper.classList.remove('loading');
      });
  });
}

document.addEventListener('DOMContentLoaded', initKnowledgeTypeFilter);





    function knowledgeFilter() {
     document.addEventListener('click', function (e) {
    const subcatLink = e.target.closest('.knowledge-cat-link');
    if (!subcatLink) return;

    e.preventDefault();

    const subcatId = subcatLink.getAttribute('data-subcat-id');
    const section = subcatLink.closest('.knowledge-archive-section');
    if (!section) return;

    const typeSlug = section.getAttribute('data-type');
    const sectionContainer = section.querySelector('.knowledge-list');

    // 🔹 USUWANIE active ze wszystkich i dodawanie do klikniętego
    section.querySelectorAll('.knowledge-cat-link').forEach(link => {
        link.classList.remove('active');
    });
    subcatLink.classList.add('active');

    const data = new FormData();
    data.append('action', 'filter_knowledge');
    data.append('subcat_id', subcatId);
    data.append('type_slug', typeSlug);

    section.classList.add('loading');

    fetch(mg_ajax.ajax_url, {
        method: 'POST',
        body: data,
    })
        .then(res => res.json())
        .then(response => {
            if (response.success && sectionContainer) {
                const temp = document.createElement('div');
                temp.innerHTML = response.data.trim();

                const newList = temp.querySelector('.knowledge-list');

                if (newList) {
                    sectionContainer.innerHTML = newList.innerHTML;
                } else {
                    sectionContainer.innerHTML = response.data;
                }
            }
            section.classList.remove('loading');
        })
        .catch(err => {
            console.error('AJAX error:', err);
            section.classList.remove('loading');
        });
});



    }

    function initGsapParallax() {
        if (window.matchMedia("(min-width: 1200px)").matches) {
            gsap.utils.toArray('.image-ani').forEach(container => {
                const img = container.querySelector('img');
        
                if (!img) return;
        
                gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        scrub: true,
                        pin: false,
                    }
                }).fromTo(img,
                    { yPercent: -10, ease: 'none' },
                    { yPercent: 10, ease: 'none' }
                );
            });
        }
    }

    // wywołaj od razu
    initGsapParallax();

    // nasłuchiwanie zmiany rozdzielczości (resize)
    window.matchMedia("(min-width: 1200px)").addEventListener("change", e => {
    // usuń stare scrollTrigger'y
    ScrollTrigger.getAll().forEach(st => st.kill());
    // odpal ponownie jeśli spełnia warunki
    if (e.matches) {
        initGsapParallax();
    }
    });

    // Lazy loading images
    function handleLazyLoading() {
        if ('loading' in HTMLImageElement.prototype) {
            const images = document.querySelectorAll('img[loading="lazy"]');
            images.forEach(img => {
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                }
            });
        } else {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
            script.async = true;
            script.onerror = () => console.warn('LazySizes failed to load');
            document.body.appendChild(script);
        }
    }

    // Placeholder logic
    function handlePlaceholders() {
        $('input, textarea')
            .on('focus', function() {
                const $this = $(this);
                $this.data('placeholder', $this.attr('placeholder')).attr('placeholder', '');
            })
            .on('blur', function() {
                const $this = $(this);
                $this.attr('placeholder', $this.data('placeholder'));
            });
    }

    // Hamburger menu toggle
    function handleHamburger() {
        $('.hamburger').on('click', function() {
            $('body, html').toggleClass('menu-open');
            $('.navbar').addClass('navbar-scrolled');
            $('.navbar__fixed').toggleClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).toggleClass('open-m');
            $('.hamburger').toggleClass('hamburger-active');
        });

        $('.mobile-overlay ul li').on('click', function() {
            $('body, html').removeClass('menu-open');
            $('.navbar__fixed').removeClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).removeClass('open-m');
            $('.hamburger').removeClass('hamburger-active');
        });
    }

    // LANG SWITCHER
    function langSwitcher() {
        const switcher = document.querySelector('.lang-switcher');
        const button = switcher?.querySelector('.lang-button');

        if (button) {
            button.addEventListener('click', function () {
                switcher.classList.toggle('open');
            });

            document.addEventListener('click', function (e) {
                if (!switcher.contains(e.target)) {
                    switcher.classList.remove('open');
                }
            });
        }
    }

    // FAQ
    function faq() {
        document.addEventListener("DOMContentLoaded", () => {
  const faqs = document.querySelectorAll(".services-faq-accordion .faq-item");

  faqs.forEach((item) => {
    const btn = item.querySelector(".faq-question");
    const answer = item.querySelector(".faq-answer");

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      if (isOpen) {
        // zamykanie
        answer.style.height = answer.scrollHeight + "px"; // ustaw aktualną wysokość
        requestAnimationFrame(() => {
          answer.style.height = "0"; // animuj do 0
        });
        item.classList.remove("active");
        btn.setAttribute("aria-expanded", "false");
      } else {
        // otwieranie
        answer.style.height = answer.scrollHeight + "px";
        answer.addEventListener(
          "transitionend",
          () => {
            if (item.classList.contains("active")) {
              answer.style.height = "auto"; // 🔥 po animacji wysokość auto
            }
          },
          { once: true }
        );

        item.classList.add("active");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
});


    }

    function teamFilters() {
        document.addEventListener("DOMContentLoaded", function () {
            const buttons = document.querySelectorAll(".team-list-filters button");
            const items = document.querySelectorAll(".others li");
          
            buttons.forEach((btn) => {
              btn.addEventListener("click", () => {
                const filter = btn.getAttribute("data-filter");
          
                // reset aktywnego przycisku
                buttons.forEach((b) => b.classList.remove("active"));
                btn.classList.add("active");
          
                items.forEach((item) => {
                  if (filter === "*" || item.classList.contains(filter.substring(1))) {
                    item.style.display = "block";
                  } else {
                    item.style.display = "none";
                  }
                });
              });
            });
          });
          
    }

    function accordingServices() {
  const serviceItems = document.querySelectorAll(".home-services li");

  if (!serviceItems.length) return;

  // 🔹 aktywuj pierwszy element na starcie
  const firstItem = serviceItems[0];
  const firstPanel = firstItem.querySelector(".home-services-more");
  if (firstItem && firstPanel) {
    firstItem.classList.add("active");
    firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
  }

  // 🔹 obsługa kliknięć
  serviceItems.forEach(item => {
    const heading = item.querySelector(".home-services-lead .btn-black");
    const more = item.querySelector(".home-services-more");

    if (heading && more) {
      heading.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        // zamknij wszystkie inne sekcje
        serviceItems.forEach(i => {
          i.classList.remove("active");
          const panel = i.querySelector(".home-services-more");
          if (panel) {
            panel.style.maxHeight = null;
          }
        });

        // jeśli kliknięty był zamknięty — otwórz go
        if (!isActive) {
          item.classList.add("active");
          more.style.maxHeight = more.scrollHeight + "px";
        }
      });
    }
  });
    }


    // ========================
// SWIPER – partners slider
// ========================
function initSwiper() {
  const partnersSlider = document.querySelector('.partners-gallery .swiper');
  if (partnersSlider) {
    new Swiper(partnersSlider, {
      modules: [Navigation],
      slidesPerView: 2,
      loop: true,
      spaceBetween: 30,
      navigation: {
        nextEl: '.partners-next',
        prevEl: '.partners-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 5,
        },
      },
    });
  }

  const valuesSlider = document.querySelector('.about-values-slider');
  if (valuesSlider) {
    new Swiper(valuesSlider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: -110,
      navigation: {
        nextEl: '.values-next',
        prevEl: '.values-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
    });
  }

  const opinionsSlider = document.querySelector('.career-opinions-slider');
  if (opinionsSlider) {
    new Swiper(opinionsSlider, {
      modules: [Navigation, EffectFade],
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true, // płynne przejście
      },
      loop: true,
      navigation: {
        nextEl: '.career-next',
        prevEl: '.career-prev',
      },
    });
  }

  const newsSlider = document.querySelector('.home-news-slider');
  if (newsSlider) {
    new Swiper(newsSlider, {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.news-next',
        prevEl: '.news-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 1.5,
        },
        1200: {
          slidesPerView: 2.5,
        },
        1920: {
          slidesPerView: 3,
        }
      },
    });
  }


  const otherSlider = document.querySelector('.single-other-posts-slider');
  if (otherSlider) {
    new Swiper(otherSlider, {
      modules: [Navigation, Pagination],
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.news-next',
        prevEl: '.news-prev',
      },
      pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 1.5,
        },
        1200: {
          slidesPerView: 3,
        }
      },
    });
  }

  const gallerySlider = document.querySelector('.knowledge-content-row-gallery .swiper');
  if (gallerySlider) {
    new Swiper(gallerySlider, {
      modules: [Navigation],
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.gallery-next',
        prevEl: '.gallery-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        768: {
          slidesPerView: 1.5,
        },
        1200: {
          slidesPerView: 3,
        }
      },
    });
  }
  
}





})(jQuery);
